/** Relative presets: the "last N" (or "next N") windows the panel offers as one-click
 *  buttons. A pick stays relative on the wire (`now-15m..now`) — the backend resolves it
 *  per request, so a refreshed grid keeps moving. */
import type { TimeWindowUnit } from './types';

export interface TimeWindowPresetGroup {
  unit: TimeWindowUnit;
  label: string;
  amounts: readonly number[];
}

export const TIME_WINDOW_PRESETS: readonly TimeWindowPresetGroup[] = [
  { unit: 'minutes', label: 'Minutes', amounts: [5, 10, 15, 20, 30] },
  { unit: 'hours', label: 'Hours', amounts: [1, 2, 3, 6, 8, 12, 16] },
  { unit: 'days', label: 'Days', amounts: [1, 2, 3, 4, 5, 6] },
  { unit: 'weeks', label: 'Weeks', amounts: [1, 2, 3, 4] },
  { unit: 'months', label: 'Months', amounts: [1, 2, 3, 4, 5, 6] },
];
